export default "__VITE_ASSET__Pn71aI8J__"